const colors = {
  primary: {
    lighter: 'rgba(255, 203, 231, 1)',
    light: 'rgba(255, 143, 217, 1)',
    main: 'rgba(236, 32, 207, 1)',
    dark: 'rgba(181, 21, 146, 1)',
    darker: 'rgba(99, 5, 89, 1)',
    transparent: {
      8: 'rgba(236, 32, 207, 0.08)',
      12: 'rgba(236, 32, 207, 0.12)',
      16: 'rgba(236, 32, 207, 0.16)',
      24: 'rgba(236, 32, 207, 0.24)',
      32: 'rgba(236, 32, 207, 0.32)',
      48: 'rgba(236, 32, 207, 0.48)',
    },
  },

  secondary: {
    lighter: 'rgba(156, 255, 249, 1)',
    light: 'rgba(91, 244, 254, 1)',
    main: 'rgba(11, 213, 226, 1)',
    dark: 'rgba(8, 119, 181, 1)',
    darker: 'rgba(9, 68, 122, 1)',
    transparent: {
      8: 'rgba(11, 213, 226, 0.08)',
      12: 'rgba(11, 213, 226, 0.12)',
      16: 'rgba(11, 213, 226, 0.16)',
      24: 'rgba(11, 213, 226, 0.24)',
      32: 'rgba(11, 213, 226, 0.32)',
      48: 'rgba(11, 213, 226, 0.48)',
    },
  },

  tertiary: {
    lighter: 'rgba(212, 203, 255, 1)',
    light: 'rgba(171, 152, 255, 1)',
    main: 'rgba(124, 103, 218, 1)',
    dark: 'rgba(61, 42, 146, 1)',
    darker: 'rgba(33, 19, 97, 1)',
    transparent: {
      8: 'rgba(124, 103, 218, 0.08)',
      12: 'rgba(124, 103, 218, 0.12)',
      16: 'rgba(124, 103, 218, 0.16)',
      24: 'rgba(124, 103, 218, 0.24)',
      32: 'rgba(124, 103, 218, 0.32)',
      48: 'rgba(124, 103, 218, 0.48)',
    },
  },

  success: {
    lighter: 'rgba(178, 255, 237, 1)',
    light: 'rgba(82, 219, 186, 1)',
    main: 'rgba(67, 179, 172, 1)',
    dark: 'rgba(25, 114, 134, 1)',
    darker: 'rgba(9, 63, 75, 1)',
    transparent: {
      8: 'rgba(67, 179, 172, 0.08)',
      12: 'rgba(67, 179, 172, 0.12)',
      16: 'rgba(67, 179, 172, 0.16)',
      24: 'rgba(67, 179, 172, 0.24)',
      32: 'rgba(67, 179, 172, 0.32)',
      48: 'rgba(67, 179, 172, 0.48)',
    },
  },

  warning: {
    lighter: 'rgba(255, 243, 212, 1)',
    light: 'rgba(255, 218, 123, 1)',
    main: 'rgba(255, 199, 54, 1)',
    dark: 'rgba(187, 123, 0, 1)',
    darker: 'rgba(139, 75, 0, 1)',
    transparent: {
      8: 'rgba(255, 199, 54, 0.08)',
      12: 'rgba(255, 199, 54, 0.12)',
      16: 'rgba(255, 199, 54, 0.16)',
      24: 'rgba(255, 199, 54, 0.24)',
      32: 'rgba(255, 199, 54, 0.32)',
      48: 'rgba(255, 199, 54, 0.48)',
    },
  },

  error: {
    lighter: 'rgba(255, 214, 214, 1)',
    light: 'rgba(254, 161, 161, 1)',
    main: 'rgba(245, 92, 92, 1)',
    dark: 'rgba(183, 33, 54, 1)',
    darker: 'rgba(108, 17, 17, 1)',
    transparent: {
      8: 'rgba(245, 92, 92, 0.08)',
      12: 'rgba(245, 92, 92, 0.12)',
      16: 'rgba(245, 92, 92, 0.16)',
      24: 'rgba(245, 92, 92, 0.24)',
      32: 'rgba(245, 92, 92, 0.32)',
      48: 'rgba(245, 92, 92, 0.48)',
    },
  },

  gray: {
    100: 'rgba(238, 239, 254, 1)',
    200: 'rgba(223, 224, 235, 1)',
    300: 'rgba(196, 197, 211, 1)',
    400: 'rgba(165, 166, 182, 1)',
    500: 'rgba(129, 131, 152, 1)',
    600: 'rgba(94, 96, 114, 1)',
    700: 'rgba(65, 67, 85, 1)',
    800: 'rgba(37, 40, 66, 1)',
    900: 'rgba(2, 5, 36, 1)',
    transparent: {
      8: 'rgba(129, 131, 152, 0.08)',
      12: 'rgba(129, 131, 152, 0.12)',
      16: 'rgba(129, 131, 152, 0.16)',
      24: 'rgba(129, 131, 152, 0.24)',
      32: 'rgba(129, 131, 152, 0.32)',
      48: 'rgba(129, 131, 152, 0.48)',
    },
  },

  text: {
    onLight: {
      primary: 'rgba(2, 5, 36, 1)',
      secondary: 'rgba(94, 96, 114, 1)',
      disabled: 'rgba(94, 96, 114, 1)',
    },
    onDark: {
      primary: 'rgba(255, 255, 255, 1)',
      secondary: 'rgba(143, 150, 155, 1)',
      disabled: 'rgba(99, 109, 117, 1)',
    },
  },

  gradients: {
    primary: 'linear-gradient(90deg, #EC20CF 0%, #0BD5E2 100%)',
    purple: 'linear-gradient(90deg, #D908AA 0%, #052949 100%)',
    blue: 'linear-gradient(90deg, #0BD5E2 0%, #0877B5 64.85%, #01203C 100%)',
  },
}

export default colors
